import React from 'react';
import NavBarButtons from "./NavBarButtons";
import {useForm} from "../../_hooks/useForm";
import {useSelector} from "react-redux";
import {AlertError} from "../Login/style";
import {PersonalDataStepBox} from './style';

const PersonalStep = (props) => {
    const {userId, firstName, lastName, userName, email, partnerId} = useSelector(state => state.repository.user);
    const {msgError} = useSelector(state => state.ui);

    const [formValues, handleInputChange] = useForm({
        partnerId: partnerId,
        firstname: firstName,
        lastname: lastName,
        address: '',
        city: '',
        state: '',
        zipcode: '',
        email: email,
        userId: userId
    });

    const {firstname, lastname, address, city, state, zipcode} = formValues;

    return (
        <>
            <PersonalDataStepBox>
                <form id="personal-data-form" name="personal-data-form" className="nobottommargin">
                    <h5>User ID: <span>{userId}</span></h5>
                    <div className="line nomargin pb-4"/>

                    {
                        msgError &&
                        <AlertError>
                            {msgError}
                        </AlertError>
                    }

                    <div className="col_half">
                        <label htmlFor="login-form-email">Email:</label>
                        <input type="text"
                               id="email"
                               name="email"
                               value={email}
                               readOnly
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_half col_last">
                        <label htmlFor="login-form-email">Username:</label>
                        <input type="text"
                               id="username"
                               name="username"
                               value={userName}
                               readOnly
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_half">
                        <label htmlFor="login-form-email">First Name:</label>
                        <input type="text"
                               id="firstname"
                               name="firstname"
                               value={firstname}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_half col_last">
                        <label htmlFor="login-form-email">Last Name:</label>
                        <input type="text"
                               id="lastname"
                               name="lastname"
                               value={lastname}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_full">
                        <label htmlFor="login-form-email">Address:</label>
                        <input type="text"
                               id="address"
                               name="address"
                               value={address}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_two_fifth">
                        <label htmlFor="login-form-email">City:</label>
                        <input type="text"
                               id="city"
                               name="city"
                               value={city}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_one_third">
                        <label htmlFor="login-form-email">State:</label>
                        <input type="text"
                               id="state"
                               name="state"
                               value={state}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>

                    <div className="col_one_fourth col_last">
                        <label htmlFor="login-form-email">Zip:</label>
                        <input type="text"
                               id="zipcode"
                               name="zipcode"
                               value={zipcode}
                               onChange={handleInputChange}
                               className="form-control not-dark"/>
                    </div>
                </form>

                <NavBarButtons data={formValues} onDataChange={handleInputChange} previousStep={props.previousStep} nextStep={props.nextStep}
                               currentStep={props.currentStep}/>
            </PersonalDataStepBox>
        </>
    );
};

export default PersonalStep;
